import { HTTP_TOKEN } from "./http";

export const getDashCampaign = () => {
  return HTTP_TOKEN.get("dash-campaign").then(result => {
    return result.data;
  });
};

export const updateDashCampaign = data => {
  return HTTP_TOKEN.post("dash-campaign", data).then(result => {
    return result.data;
  });
};

